// extracted by mini-css-extract-plugin
module.exports = {"RecommendedTopList":"RecommendedTopList_RecommendedTopList__L80Or","ListItem":"RecommendedTopList_ListItem__WZJbw"};